import { BCMSCurrency, BCMSRecord, DisabledPrompt, Link, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import { SVGAsset } from "res";

import "./styles.css";

export default function CurrentAlertsContent(props) {
    const navigate = useRoute();    
    const context = useBCMSContext();

    BCMSRecord.globalControllerFor(Classes, context);
    
    const account = Account.initAll()[0];
    const thresholdBalance = BCMSCurrency.init(100);

    const onBelowThreshold = evt => navigate("/advancedAlerts/belowThreshold");

    return (
        <div className="current-alerts-content back-link-padding">
            <Link to="/advancedAlerts/manageAlerts" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Current Alerts</p>

            <div className="flex-container flex-vertical current-alerts-container">
                <DisabledPrompt>
                    <div className="flex-container flex-horizontal current-alert clickable">
                        <p className="flex-width">Password Changed</p>
                        <SVGAsset id="RightChevronIcon" className="set-width" />
                    </div>
                </DisabledPrompt>

                <DisabledPrompt>
                    <div className="flex-container flex-horizontal current-alert clickable">
                        <p className="flex-width">User ID Changed</p>
                        <SVGAsset id="RightChevronIcon" className="set-width" />
                    </div>
                </DisabledPrompt>

                <DisabledPrompt>
                    <div className="flex-container flex-horizontal current-alert clickable">
                        <p className="flex-width">Phone Number Changed in Online Banking</p>
                        <SVGAsset id="RightChevronIcon" className="set-width" />
                    </div>
                </DisabledPrompt>

                <div className="flex-container flex-horizontal current-alert below-threshold clickable" onClick={ onBelowThreshold }>
                    <div className="flex-container flex-vertical flex-width">
                        <p>Account Balance Below Threshold</p>
                        <p className="account-details">{ account.number } | { thresholdBalance.format() }</p>
                    </div>

                    <SVGAsset id="RightChevronIcon" className="set-width" />
                </div>

                <DisabledPrompt>
                    <div className="flex-container flex-horizontal current-alert clickable">
                        <p className="flex-width">Bank Updates</p>
                        <SVGAsset id="RightChevronIcon" className="set-width" />
                    </div>
                </DisabledPrompt>
            </div>
        </div>
    );
}